import 'mmenu-js';

const init = () => {
  if (!document.querySelector('#mobile-menu')) return;

  const menu = new Mmenu(
    '#mobile-menu',
    {
      //options
    },
    {
      // configuration
      classNames: {
        selected: 'mm-li--selected'
      },
      offCanvas: {
        page: {
          nodetype: 'main',
          selector: '#page',
        },
        menu: {
          insertMethod: 'append',
          insertSelector: '#mmenu-append',
        },
      },
    },
  );

  const api = menu.API;
  const mobileMenu = document.querySelector('.js-mobile-menu');
  const burger = document.querySelector('.js-menu-burger');

  const mediaQuery = '(min-width: 1200px)';
  const mediaQueryList = window.matchMedia(mediaQuery);

  const firstMenuPanel = document.querySelector('#mm-1');

  if (firstMenuPanel) {
    const firstMenuPanelHeader = firstMenuPanel.querySelector('.mm-navbar');

    if (firstMenuPanelHeader) {
      firstMenuPanel.removeChild(firstMenuPanelHeader);
    }
  }

  if (burger) {
    burger.addEventListener('click', function () {
      if (burger.getAttribute('aria-expanded') == 'false') {
        openMenu(mobileMenu, burger, api);
      } else {
        closeMenu(mobileMenu, burger, api);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key == 'Escape' && burger.getAttribute('aria-expanded') == 'true') {
        closeMenu(mobileMenu, burger, api);
      }
    });

    mediaQueryList.addEventListener(
      'change',
      handleResize(api, mobileMenu, burger),
    );
  }
};

const handleResize = (api, mobileMenu, burger) => event => {
  if (event.matches) {
    closeMenu(mobileMenu, burger, api);
  }
};

const openMenu = (mobileMenu, burger, api) => {
  burger.setAttribute('aria-expanded', true);
  mobileMenu.setAttribute('aria-hidden', false);
  document.querySelector('body').classList.add('overflow-y-hidden');
  api.open();
};

const closeMenu = (mobileMenu, burger, api) => {
  burger.setAttribute('aria-expanded', false);
  mobileMenu.setAttribute('aria-hidden', true);
  document.querySelector('body').classList.remove('overflow-y-hidden');
  api.close();
};

const mobileMmenu = {
  init,
};

export default mobileMmenu;
